import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ["activityPopup"];
  timeout = null;

  connect() {
    this.show_popup();
  }

  show_popup() {
    if (this.hasActivityPopupTarget) {
      this.activityPopupTarget.classList.remove("show");

      requestAnimationFrame(() => {
        this.activityPopupTarget.classList.add("show");

        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
          this.close_popup();
        }, 20000);
      });
    }
  }

  close_popup() {
    this.activityPopupTarget.classList.remove("show");

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    setTimeout(() => {
      this.activityPopupTarget.remove();
    }, 500);
  }
}
